export default {
  methods: {},
}
